module.exports = __webpack_public_path__ + "img/code-offcial.7cf3c0b.jpg";